<script setup lang="ts">
import { createFetchRequester } from '@algolia/requester-fetch'
import { singleIndex } from 'instantsearch.js/es/lib/stateMappings'
import algoliasearch from 'algoliasearch'
import type {
  IndexWidget,
  InstantSearchOptions,
  StateMapping,
  Widget,
} from 'instantsearch.js'
import AlgoliaLookbookHits from '../Algolia/AlgoliaLookbookHits.vue'
import type { TemplatesPlpShopTheLookProps } from './TemplatesPlpShopTheLook.props'

const props = defineProps<TemplatesPlpShopTheLookProps>()
const appConfig = useAppConfig()

const hitsPerPage = ref(24)

const searchClient = algoliasearch(
  useRuntimeConfig().public.algolia.applicationId,
  useRuntimeConfig().public.algolia.apiKey,
  { requester: createFetchRequester() }
)

// instant search configuration
const widgets = ref<(Widget | IndexWidget)[]>([
  useAisStats({}),
  useAisInfiniteHits({
    showPrevious: true,
    cache: useAisInfiniteHitsStatefulCache('index'),
  }),
  useAisConfigure({
    searchParameters: {
      //@ts-ignore - consiglio di matte
      hitsPerPage: hitsPerPage.value,
      distinct: true,
      filters: `LookFamily: "${props.filterName}"`,
    },
  }),
])

const router = useAisRouter()
const routing = {
  router: router.value.router!,
  stateMapping: singleIndex(props.filterName) as StateMapping,
}

const configuration = computed<InstantSearchOptions>(() => ({
  indexName: appConfig.currentAlgoliaLookbookIndex,
  searchClient,
  routing,
}))

const { breadcrumbs } = useBreadcrumbs({
  dataOrigin: 'amplience',
  currentPageTitle: props?.parentPage?.categoryTitle || '',
  pageData: props?.parentPage?.parentPage || null,
})
</script>

<template>
  <div>
    <AisInstantSearch
      :widgets="widgets"
      :configuration
      instance-key="shopthelook"
    >
      <AlgoliaLookbookHits />
    </AisInstantSearch>

    <UIBreadcrumbs
      v-if="breadcrumbs"
      class="text-text-primary positive-padding py-6"
      :items="breadcrumbs"
    />
  </div>
</template>
